import React, { ReactNode } from "react";
import { Reveal } from "./Reveal";
type SectionTitleProps = {
  children: ReactNode;
  intro?: ReactNode;
  align?: "center" | "left";
  tone?: "dark" | "light";
};
export function SectionTitle({
  children,
  intro,
  align = "center",
  tone = "dark"
}: SectionTitleProps) {
  const alignment = align === "center" ? "text-center mx-auto" : "text-left";
  return <Reveal className={`max-w-3xl ${alignment}`} data-id="element-608" data-mp="ilscvrv8ank7">
      <h2 className={`font-display text-3xl font-bold leading-[1.15] sm:text-4xl lg:text-5xl ${tone === "dark" ? "text-cocoa" : "text-cream"}`} data-id="element-609" data-mp="imldeb3lggtw">
        {children}
      </h2>
      {intro && <p className={`mt-5 text-lg leading-relaxed ${tone === "dark" ? "text-cocoa-light" : "text-cream/80"}`} data-id="element-610" data-mp="8pp1rwiefel4">
          {intro}
        </p>}
    </Reveal>;
}